import React, { useRef } from "react";
import Webcam from "react-webcam";
import Button from "../Button/Button";
import "./WebcamComponent.css";
import { useTranslation } from "react-i18next";

function WebcamComponent({ hidden, submitImg }) {
  const { t } = useTranslation();
  const webcamRef = useRef(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    submitImg(imageSrc);
  };

  return (
    !hidden && (
      <div className="webcam-container">
        <Webcam
          ref={webcamRef}
          audio={false}
          screenshotFormat="image/jpeg"
          width={300}
          height={300}
          className="webcam-circle"
          minScreenshotWidth={380}
        />
        <Button label={t("common.savePhoto")} onClick={capture} />
      </div>
    )
  );
}

export default WebcamComponent;
